import { listVal } from "@paroi/data-formatters-lib";
import {
  type ApiRequestResponse,
  type PaginationOptions,
  fetchQuery,
} from "../api/shared/http-client";
import { type Log, formatLog } from "../helpers/format-logs";

export async function fetchLogs({
  limit,
  page,
}: PaginationOptions): Promise<ApiRequestResponse<Log[]>> {
  const { data, pagination } = await fetchQuery(`activities?limit=${limit}&page=${page}`);
  return {
    data: listVal(data, formatLog),
    pagination,
  };
}
